// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"d69e1bf8","322":"cadf0fb2","453":"dd181ba9","462":"27ed3510","491":"14c533b0","745":"718d9f0d","764":"f8833576","825":"02c7550c","963":"1b415d67","977":"faf4c2cd"}[chunkId] + ".chunk.js";
};